import { module } from 'angular';
import { ContentDictionaryDirective } from './directives/content-dictionary';
import { SystemDictionaryDirective } from './directives/system-dictionary';
import { ContentDictionaryService } from './services/content-dictionary-service';
export var ngModule = module('gn.audio.cg.dictionary', [])
    .service('contentDictionary', ContentDictionaryService)
    .directive('contentDictionary', ContentDictionaryDirective)
    .directive('systemDictionary', SystemDictionaryDirective);
